import { render, staticRenderFns } from "./AddPlazosComponent.vue?vue&type=template&id=7224dd0d"
import script from "./AddPlazosComponent.vue?vue&type=script&lang=js"
export * from "./AddPlazosComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports